export const auditLogPaths = {
  absolute: '/:clientId/audit-log',
} as const;
